/* app/ui/map/map.load */

define(
	'app/ui/map/map.load',[
		'jquery',
		'app/ui/map/map.control',
		'app/ui/map/map.interactive',
		'app/ui/map/map.baidu.control',
		'pubsub'
	],
	function($, MapControl, MapInteractive, BaiduMap) {

		var MapLoad;

		// A new Google Maps API key should be created for each new project
		var apiKey = 'AIzaSyA_Tg7Jf6PKMr69MB9U-RfIODgKLlm_Tbc';
		var apiLoaded = false;
		var google;
		var $maps;

		return {
			init: function($elms) {
				MapLoad = this;
				$maps = $elms;

				var $firstMap = $maps.eq(0);

				// If only interactive map is on page initialise the module for this
				// The MapInteractive module will only load the API code if the map is toggled to display
				// Otherwise load API and init MapControl module
				if ($maps.length) {
					//this just for debug on live, to show the baidu map
					if (window.location.href.includes('debugBaidu=true')) {
						BaiduMap.init($maps);
						return;
					}
					if ($maps.length === 1 && $firstMap.attr('data-map-type') === 'interactive') {
						if ($('html').attr('lang') === 'zh-cn') {
							// in cn site, check if google script accessiable, if not use baidu map
							$.ajax({
								type: "GET",
								url: "https://www.google.com/jsapi",
								dataType: "script",
								timeout: 1500,
								success: function (response, textS, xhr) {
									MapInteractive.init($firstMap);
									MapLoad.loadApi();
								},
								error: function (xmlHttpRequest, textStatus, errorThrown) {
									BaiduMap.init($maps);
								}
							});
						}
						else {
							MapInteractive.init($firstMap);
							MapLoad.loadApi();
						}
						
					} else {
						if ($('html').attr('lang') === 'zh-cn') {
							$.ajax({
								type: "GET",
								url: "https://www.google.com/jsapi",
								dataType: "script",
								timeout: 1000,
								success: function (response, textS, xhr) {
									MapControl.init($maps);
									MapLoad.loadApi();
								},
								error: function (xmlHttpRequest, textStatus, errorThrown) {
									BaiduMap.init($maps);
								}
							});
						}
						else {
							MapControl.init($maps);
							MapLoad.loadApi();
						}
					}
				}
			},

			// Load Google Maps API version 3
			loadApi: function() {
				$.getScript('https://www.google.com/jsapi', function() {
					window.google.load('maps', '3', {
						other_params: '&key=' + apiKey,
						callback: MapLoad.mapApiLoaded
					});
				});
				//$.getScript('https://www.google.com/jsapi')
				//.done(function () {
				//	window.google.load('maps', '3', {
				//		other_params: '&key=' + apiKey,
				//		callback: MapLoad.mapApiLoaded
				//	});
				//})
				//.fail(function () {
				//	console.log('fail');
				//});
			},

			// Callback function once API is loaded
			mapApiLoaded: function() {
				apiLoaded = true;
				google = window.google;

				$.publish('/map/apiLoaded');
			},

			// Utility function to return API status and google object
			getMapApiStatus: function () {
				return {
					loaded: apiLoaded,
					google: google
				};
			}
		};
	}
);
